let featureFlagAdminVisible = true;

export const setFeatureFlagAdminVisible = (visible: boolean): void => {
  featureFlagAdminVisible = visible;
};

export const isFeatureFlagAdminVisible = (): boolean => featureFlagAdminVisible;
